var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const type = "application/javascript";
export const getCrossOriginWorkerURL = (originalWorkerUrl) => __awaiter(void 0, void 0, void 0, function* () {
    if (!originalWorkerUrl.includes("://") ||
        originalWorkerUrl.includes(window.location.origin)) {
        // The same origin - Worker will run fine
        return originalWorkerUrl;
    }
    else {
        const source = yield fetch(originalWorkerUrl);
        return URL.createObjectURL(new Blob([yield source.text()], { type }));
    }
});
